import { useState, useEffect } from 'react';
import { getCustomPlanTypes } from './api';
import { plans as basePlans } from './utils';

export function useAllPlans() {
  const [allPlans, setAllPlans] = useState(basePlans);

  useEffect(() => {
    getCustomPlanTypes()
      .then(res => {
        const custom = res.data || [];
        setAllPlans([...basePlans, ...custom]);
      })
      .catch(() => {}); // eslint-disable-line
  }, []);

  return allPlans;
}
